import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { useI18n } from '../../../i18n';

/* Cycles through the auth.texts marketing lines */
export default function RotatingTagline({ className = '', align = 'left' }) {
  const { getRaw } = useI18n();
  const texts = getRaw('auth.texts') || [];
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (texts.length === 0) return undefined;
    const interval = setInterval(() => {
      setCurrent(prev => (prev + 1) % texts.length);
    }, 3500);
    return () => clearInterval(interval);
  }, [texts.length]);

  if (texts.length === 0) return null;

  return (
    <div className={`h-7 overflow-hidden relative ${className}`}>
      <AnimatePresence mode="wait">
        <motion.p
          key={current}
          initial={{ y: 24, opacity: 0, filter: 'blur(4px)' }}
          animate={{ y: 0, opacity: 1, filter: 'blur(0px)' }}
          exit={{ y: -24, opacity: 0, filter: 'blur(4px)' }}
          transition={{ duration: 0.4 }}
          className={`absolute left-0 right-0 text-sm sm:text-base font-medium flex items-center gap-2 ${align === 'center' ? 'justify-center' : ''}`}
          style={{ color: 'var(--accent)' }}
        >
          <Sparkles size={15} />
          {texts[current]}
        </motion.p>
      </AnimatePresence>
    </div>
  );
}
